import { Shell } from '../../components/layout/Shell.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { BUILD, SOC } from '../../constants/company';
import { ACCESS_ROLE, ROLE_LABEL } from '../../lib/access';
import { entreesMenuPlus, outilsEnGroupes } from '../../lib/menu-plus';
import { tr } from '../../lib/i18n';
import { useReglages } from '../../api/reglages.jsx';
import { useSession } from '../../api/session.jsx';
import { CLE_PACK_IA, packIaActif } from '../../lib/pack-ia';
import { C } from '../../theme/palette';

export function PlusPage({ onNav, soc, onLock, estMixte, univers, setUnivers }) {
  const { reglageJson } = useReglages();
  const { session } = useSession();
  const mag = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';
  // Le Pack IA se facture en sus : sans lui, l'assistant s'efface (voir
  // lib/menu-plus.js, partage avec la navigation laterale).
  const avecIa = packIaActif(reglageJson(CLE_PACK_IA, null));
  // Le patron salarie de sa societe a son espace d'employe : l'ouvrier, lui,
  // l'a deja dans sa barre du bas.
  const espaceTerrain = session?.role !== 'ouvrier' && session?.employeId != null;
  const { modules: principal, outils: autres } = entreesMenuPlus({ mag, avecIa, espaceTerrain });
  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      pageTitle="⋯ Plus"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      <div
        style={{
          background: 'linear-gradient(135deg,' + C.navy + ',' + C.navyM + ')',
          borderRadius: 14,
          padding: 16,
          marginBottom: 14,
        }}
      >
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: 'rgba(255,255,255,.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 20,
              fontWeight: 900,
              color: '#fff',
            }}
          >
            {(soc?.nom || SOC.nom).charAt(0)}
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 900, color: '#fff' }}>
              {soc?.nom || SOC.nom}
            </div>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,.5)' }}>
              {estMixte ? 'Mode Mix' : mag ? 'Magasin' : 'Bâtiment'} · SwissTech
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          fontSize: 9,
          fontWeight: 700,
          color: C.muted,
          textTransform: 'uppercase',
          marginBottom: 8,
        }}
      >
        Modules
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 9, marginBottom: 14 }}>
        {principal.map(([nav, ic, lb, col]) => (
          <div
            key={nav + lb}
            onClick={() => onNav(nav)}
            style={{
              background: C.white,
              border: '1px solid ' + C.border,
              borderRadius: 12,
              padding: '14px 12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <span
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: col + '18',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 16,
              }}
            >
              {ic}
            </span>
            <span style={{ fontSize: 11, fontWeight: 800 }}>{tr(lb)}</span>
          </div>
        ))}
      </div>
      {/* Les outils rangés par thème : travail, argent, documents, équipe,
          compte, aide — au lieu d'une seule liste de trente lignes. */}
      {outilsEnGroupes(autres).map(({ titre, entrees }) => (
        <div key={titre}>
          <div
            style={{
              fontSize: 9,
              fontWeight: 700,
              color: C.muted,
              textTransform: 'uppercase',
              marginBottom: 8,
            }}
          >
            {tr(titre)}
          </div>
          <Card style={{ marginBottom: 14 }}>
            <div style={{ padding: '5px 0' }}>
              {entrees.map(([nav, ic, lb], i) => (
                <div
                  key={nav}
                  onClick={() => onNav(nav)}
                  style={{
                    padding: '11px 14px',
                    borderBottom: i < entrees.length - 1 ? '1px solid ' + C.border : 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span style={{ fontSize: 11, fontWeight: 600 }}>
                    {ic} {tr(lb)}
                  </span>
                  <span style={{ color: C.muted }}>›</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      ))}
      {/*
        Le module fixe la grille tarifaire : le bouton de la maquette mene a
        la page Abonnement, ou le secteur se change tarif a l'appui.
      */}
      {/* Le secteur et l'abonnement sont l'affaire du patron : un employé
          voyait ce bouton sans pouvoir s'en servir. */}
      {ACCESS_ROLE === 'patron' && (
        <Btn
          label="🔄 Reconfigurer le secteur"
          ghost
          color={C.navy}
          full
          onClick={() => onNav('abonnement')}
        />
      )}
      <div style={{ marginTop: 8 }}>
        <Btn label="🚪 Se déconnecter" ghost color={C.grey} full onClick={onLock} />
      </div>
      <div
        style={{
          textAlign: 'center',
          fontSize: 9,
          color: C.muted,
          marginTop: 16,
          lineHeight: 1.6,
        }}
      >
        Connecté : {ROLE_LABEL[ACCESS_ROLE] || 'Invité'} · SwissTech v1.0
        <br />
        <span style={{ fontWeight: 800, color: C.navy }}>Build {BUILD}</span>
      </div>
    </Shell>
  );
}
